import React, { useState } from 'react';
import TextInput from '@components/application/input/textInput';
import PropTypes from 'prop-types';

const NameView = ({ firstName, lastName, nextView, updateCustomerDetails }) => {
  const [firstNameValue, setFirstNameValue] = useState(firstName);
  const [lastNameValue, setLastNameValue] = useState(lastName);

  const updateFirstName = (event) => {
    setFirstNameValue(event.target.value);
  };

  const updateLastName = (event) => {
    setLastNameValue(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!firstNameValue || !lastNameValue) {
      return;
    }
    updateCustomerDetails({
      first_name: firstNameValue,
      last_name: lastNameValue,
    });
    nextView();
  };

  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <form onSubmit={handleSubmit}>
        <section className="db-section">
          <h2 className="db-question ch-mb--3">
            Let&apos;s start with your name
          </h2>
          <div className="ch-form__group">
            <TextInput
              additionalInputClasses="ac-enquiry-form__input ac-input--capitalize ch-bc--grey-6"
              additionalLabelClasses="ch-fs--3"
              autocomplete="given-name"
              description="As on your driving licence"
              errorMessage="Please enter your first name"
              inputId="enquiry_first_name"
              inputName="enquiry[first_name]"
              labelName="First name"
              onChange={updateFirstName}
              requiresNameValidation
              value={firstNameValue}
            />
          </div>
          <div className="ch-form__group">
            <TextInput
              additionalInputClasses="ac-enquiry-form__input ac-input--capitalize ch-bc--grey-6"
              additionalLabelClasses="ch-fs--3"
              autocomplete="family-name"
              description="As on your driving licence"
              errorMessage="Please enter your last name"
              inputId="enquiry_last_name"
              inputName="enquiry[last_name]"
              labelName="Last name"
              onChange={updateLastName}
              requiresNameValidation
              value={lastNameValue}
            />
          </div>
        </section>
        <section className="db-section db-section--cta">
          <button
            className="ch-btn ch-btn--block ch-btn--cta"
            onClick={handleSubmit}
            type="submit"
          >
            Next: Contact details
          </button>
        </section>
      </form>
    </div>
  );
};

export default NameView;

NameView.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  nextView: PropTypes.func,
  updateCustomerDetails: PropTypes.func,
};
